export const ICON_PADDING = 10;
export const RESET_ICON_SIZE = 15;
export const VISIBLE_VALUE_ICON_SIZE = 24;
export const SEARCH_ICON_SIZE = 24;

export const modalContainerToHideInputCursorDataHook = 'modal-content';
export const modalContainerToHideInputCursorSelector = `[data-hook="${modalContainerToHideInputCursorDataHook}"]`;
